import { render, staticRenderFns } from "./RatingView.vue?vue&type=template&id=6da96fe5&"
import script from "./RatingView.vue?vue&type=script&lang=js&"
export * from "./RatingView.vue?vue&type=script&lang=js&"
import style0 from "./RatingView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports